import BaseProxy from './Base';

class ImageProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('files', parameters, 'api/v1');
  }

  submit(requestType, url, data = null, raw = false) {
    return new Promise((resolve, reject) => { 
      let i = new Image();
      i.onload = (() => resolve(i));
      i.onerror= (() => reject());
      i.src = url;
    });
  }

  fetchStatic(url) {
    return this.submit('get', url);
  }

  fetch(options) {
    this.endpoint = `${this.endpoint}/${options.file_id}/frames/${options.frame_id}`;
    return this.load();
  }

}

export default ImageProxy;
